import { z as zod } from "zod";

// This is a zod schema for the layers store get layer response 
// and get layer list response.

const seedInfoSchema = zod.object({
  seedKey: zod.string(),
  seedId: zod.string(),
  seedName: zod.string(),
  treatment_id: zod.string().nullish(),
  stand_loss: zod.number().nullish(),
});
 
const metadataSchema = zod.object({
  origin: zod.string(),
  businessCycleId: zod.string().uuid().optional(),
  productionCycleId: zod.string().uuid().optional(),
  ssurgoVersion: zod.string().optional(),
  eruVersion: zod.string().optional(),
  samplingDate: zod.date().optional(),
  lab: zod.string().optional(),
  phosphorusExtractionMethod: zod
    .enum(["Bray1", "OlsenP", "Mehlich3", "Unknown"])
    .optional(),
  cropSeasonId: zod.string().optional(),
  seedVarieties: zod.array(seedInfoSchema).optional(),
  crop: zod.string().optional(),
  numLevels: zod.number().optional(),
  year: zod.number().optional(),
  layerGroupId: zod.string().uuid().optional(),
  visibleOptionalAttributes: zod.array(zod.string()).optional(),
});
const attributeInfoSchema = zod.object({
  attributeType: zod.string().optional(),
  unitOfMeasure: zod.string().optional(),
  decimalPlaces: zod.number().optional(),
  hasNonNullValue: zod.boolean().optional(),
});
const attributeDefinitionsSchema = zod.record(
  zod.string(),
  attributeInfoSchema
);
const s3ReferenceSchema = zod.object({
  bucket: zod.string(),
  key: zod.string(),
  url: zod.string().optional(),
});
const s3RasterSchema = zod.object({
    s3_raster: s3ReferenceSchema,
    s3_raster_attribute_guide: s3ReferenceSchema,
})

const layerSchema = zod.object({
  operationId: zod.string().uuid(),
  fieldId: zod.string().uuid(),
  layerKey: zod.string().uuid(),
  layerType: zod.string(),
  version: zod.number(),
  layerRevision: zod.string(),
  status: zod.enum(["active", "disabled", "pending", "failed"]),
  name: zod.string().optional(),
  origCreationDate: zod.string().optional(),
  metadata: metadataSchema,
  attributeDefinitions: attributeDefinitionsSchema,
  s3Raster: s3RasterSchema.optional(),
  s3Geojson: s3ReferenceSchema.optional(),
  s3Geoparquet: s3ReferenceSchema.optional(),
});

export const getLayersStoreLayerResponse = zod.object({
  data: layerSchema,
});
export const getLayersStoreLayerListResponse = zod.object({
  data: zod.array(layerSchema),
});
